import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import laguage jsons
import en from "./en.json";
import th from "./th.json";

// Get selected language from local storage. If not found, set default to 'th'.
const setDefaultLanguage = () => {
  if (!localStorage.getItem("lng")) {
    localStorage.setItem("lng", "th");
  }
};

setDefaultLanguage();

// If a ?lang= query param is present (e.g. opened via QR code from mobile app),
// use it for this page load. Supported values: 'en', 'th'.
// We intentionally do NOT persist this to localStorage so the user's own web
// language preference is not overwritten by the mobile app's setting.
const resolveInitialLanguage = (): string => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const urlLang = urlParams.get("lang");
    if (urlLang && ["en", "th"].includes(urlLang)) {
      return urlLang;
    }
  } catch {
    // Ignore — fall through to localStorage
  }
  return localStorage.getItem("lng") || "th";
};

i18n.use(initReactI18next).init({
  resources: {
    th: { translation: th },
    en: { translation: en },
  },
  lng: resolveInitialLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
